import HttpClient from "@api/clients/httpClient";
import { Filter } from "@api/models/HttpClientModels";
import User from "../models/User";

const config = { endpoint: "users", };

export default class AuthorizationService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new Filter());
    }

    authorizeUserAsync = async () => {
        return await this.httpClient.getAsync<User>(
            "", {}, "authorization"
        );
    };
}